module.exports = __webpack_public_path__ + "img/index_rec.de1eedf1.png";